import rest from '@modules/rest'
import { PERSONAL_AREA } from '@content/consts/Personal'
import { mapCustomFields, mapSystemFields } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers'
import { mapPersonalInput, mapEmployeeInput } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers/personal'

export const getPersonal = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/personal-information/admission`

    const { data } = await rest.get(url)

    return [ null, data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const getNationalities = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/nationalities/admission`

    const { data } = await rest.get(url)

    return [ null, data ]
  } catch (err) {
    return [ err, [] ]
  }
}

export const updatePersonal = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/personal-information/admission`
    const body = mapPersonalInput({ data, schema })

    const response = await rest.post(url, { body })

    return [ null, response?.data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateNationalities = async (data, params) => {
  try {
    const { employeeId, companyId } = params
    const { nationalities = [] } = data || {}
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/nationalities/admission`

    const response = await rest.post(url, { body: { nationalities } })

    return [ null, response?.data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateEmployee = async (data, params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/admission`
    const body = mapEmployeeInput({ data })

    await rest.put(url, { body })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const mapSection = data => ({
  schema: data?.schema || {},
  values: data?.values || {},
})

export const getCustomFields = async (getters) => {
  const employeeId = getters.getEmployeeUuid
  const companyId = getters.getCompanyUuid
  const url = `/companies/proxy/companies/${companyId}/employees/${employeeId}/fields/admission`

  try {
    const { data } = await rest.get(url, { params: { area: PERSONAL_AREA.LABEL } })
    const fields = data?.sections || []

    return [ null, {
      systemFields: mapSystemFields(fields),
      customFields: mapCustomFields(fields),
    } ]
  } catch (err) {
    return [ err, null ]
  }
}
